export default __webpack_public_path__ + "static/media/pxgroup09.67123ab6.png";